module.exports = __webpack_public_path__ + "fonts/fa-solid-900.efbd5d2.eot";